import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TextBoxComponentsLibComponent } from './text-box-components-lib.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSelectModule } from '@angular/material/select';
import { DropdownboxComponent } from './dropdownbox/dropdownbox.component';
import { MatIconModule } from "@angular/material/icon";
import { CardComponent } from './card/card.component';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { StepperComponent } from './stepper/stepper.component';
import { PackageDetailsFormComponent } from './package-details-form/package-details-form.component';
import { PackageFormComponent } from './package-form/package-form.component';
import { DatatableComponent } from './datatable/datatable.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatTabsModule} from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox'; 
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { StepperdetailComponent } from './stepperdetail/stepperdetail.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtondropdownComponent } from './buttondropdown/buttondropdown.component';
import {MatMenuModule} from '@angular/material/menu';
import { PackageSearchComponent } from './package-search/package-search.component';
import { TemplateSearchComponent } from './template-search/template-search.component';

@NgModule({
  declarations: [TextBoxComponentsLibComponent, DropdownboxComponent, CardComponent, PackageDetailsFormComponent, PackageFormComponent, StepperComponent, DatatableComponent, StepperdetailComponent, ButtondropdownComponent, PackageSearchComponent, TemplateSearchComponent],
  imports: [
    MatGridListModule,
    MatFormFieldModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    MatSelectModule,
    BrowserModule,
    MatIconModule,
    MatCardModule,
    MatStepperModule,    
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTooltipModule,
    MatMenuModule
  ],
  exports: [TextBoxComponentsLibComponent]
})
export class TextBoxComponentsLibModule { }
